import { render, staticRenderFns } from "./LayoutCrud.vue?vue&type=template&id=6fbe851c"
import script from "./LayoutCrud.vue?vue&type=script&lang=js"
export * from "./LayoutCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports